<template>

<!-- <RainOverlay /> -->
<van-popup v-model:show="show" position="center" :overlay-style="{ overflow: 'hidden', zIndex: '10000' }" :style="{
        width: '100%',
        height: '100vh',
        color: '#fff',
        background: 'transparent',
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '10001'
    }">
    <RainOverlay />
        <div class="popupContainer">
            <div class="collect_Container">
                <img src="@/assets/collect/rainv2_top_title.png" alt="" @click="handleClick">
                <div class="close_button">
                    <img src="@/assets/collect/rainv2_close.png" alt="" @click="close">
                </div>
                <div class="top_head">
                    <div class="head_text">R$ 5.000.000 {{ $t('collect.remainingMaxTIme') }}</div>
                    <div class="head_text">R$ <span>7.777</span></div>
                </div>

                <div class="time_container">
                    <div class="time_title">
                        12X {{ $t('collect.perDay') }}
                    </div>
                    <van-row gutter="16" class="sub_container">
                        <!-- First Column -->
                        <van-col span="12">
                            <div v-for="item in firstHalf" :key="item.time" class="row_section">
                                <van-row>
                                    <van-col class="point_star" span="4">
                                        <img src="@/assets/collect/rainv2_clock.png" alt="">
                                    </van-col>
                                    <van-col class="point_text" span="20">
                                        {{ item.time }}
                                    </van-col>
                                </van-row>
                            </div>
                        </van-col>

                        <!-- Second Column -->
                        <van-col span="12">
                            <div v-for="item in secondHalf" :key="item.time" class="row_section">
                                <van-row>
                                    <van-col class="point_star" span="4">
                                        <img src="@/assets/collect/rainv2_clock.png" alt="">
                                    </van-col>
                                    <van-col class="point_text" span="20">
                                        {{ item.time }}
                                    </van-col>
                                </van-row>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="bottom_text">
                    <van-row style="padding-bottom: 10px;">
                        <van-col span="6" class="">
                            <div class="line1"></div>
                        </van-col>
                        <van-col span="12" class="title">
                            <div>{{ $t('common.activityTitle') }}</div>
                        </van-col>
                        <van-col span="6" class="">
                            <div class="line2"></div>
                        </van-col>
                    </van-row>
                    <div class="line_text">
                        {{ $t('collect.lineText1') }} R$ 5.000.000.
                    </div>
                    <div class="line_text">
                        {{ $t('collect.lineText2') }} R$ 7.777
                    </div>
                    <div class="line_text">
                        {{ $t('collect.lineText3') }}
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
    <StatusPopup ref="statusPopupRef" :content="$t('collect.oopsText') " />
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue'
import { ref, defineExpose, nextTick, onUnmounted, onMounted, watch, computed } from 'vue'
import RainOverlay from '@/components/common/rainOverlay.vue'
const show = ref(false)
const statusPopupRef = ref()

const timeList = ref([{ time: '05.30-06.29' }, { time: '06.30-07.29' }, { time: '07.30-08.29' }, { time: '05.30-06.29' },
{ time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' },
{ time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' }, { time: '05.30-06.29' },

])
const halfLength = Math.ceil(timeList.value.length / 2)

const firstHalf = computed(() => timeList.value.slice(0, halfLength))
const secondHalf = computed(() => timeList.value.slice(halfLength))
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const handleClick = () => {
    statusPopupRef.value.open()
}

defineExpose({
    open,
    close
})

</script>
<style scoped>
.popupContainer {
    background: transparent;
    display: flex;
    justify-content: center;
    background-image: linear-gradient(180deg, #F0A853 0%, #3D2E22 100%);
    box-shadow: inset 0px -2px 0px 0px rgba(221, 122, 51, 1), inset 0px 2px 0px 0px rgba(221, 122, 51, 1);
    border-radius: 20px;
    width: 85%;
    height: 85%;
    z-index: 10002;
}

.collect_Container {
    position: relative;


}

.collect_Container img {
    width: 100%;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.card_list {
    padding: 30px 25px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.point_star img {
    width: 12px;
}

.row_section {
    /* position: absolute;
    top: 40%; */
}

.point_text {
    color: #000000;
    font-size: 13px;
    padding-top: 10px;
}

.point_star {
    padding-top: 10px;
}

.close_button img {
    width: 20px;
}

.close_button {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 25px;
    right: 20px;
}

.time_container {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    border-radius: 0 0 20px 20px;
    margin: -40px 25px 0;
}

.time_title {
    padding: 15px 15px 5px;
    color: #000;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    text-align: center;
    justify-content: center;
}

.sub_container {
    padding: 0 35px 15px;
}

.bottom_text {
    padding: 10px 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 12px;
    padding: 5px;
    line-height: 20px;
}

.head_text {
    display: flex;
    text-align: center;
    justify-content: center;
    font-weight: 700;
    color: #FFFFFF;
    font-size: 15px;
    padding: 5px;
    align-items: center;
}

.head_text span {
    color: #FFE400;
    font-size: 25px;
}

.top_head {
    position: absolute;
    top: 125px;
    left: 14%;
}
</style>